import addison from './addison';
import werkzeug from './werkzeug';

export default {
  addison,
  werkzeug,
};
